const ruPluralRules = new Intl.PluralRules('ru');

/**
 * Форма слова для числа по правилам `Intl.PluralRules('ru')`.
 * @param forms `[для 1, для 2–4, для 5–20 и 0]`, напр. `['узла', 'узлов', 'узлов']`; дробные берут вторую форму.
 */
export const pluralize = (value: number, forms: readonly [string, string, string]): string => {
    switch (ruPluralRules.select(value)) {
        case 'one':
            return forms[0];
        case 'many':
            return forms[2];
        default:
            return forms[1];
    }
};

/** То же, что `pluralize`, — имя вызовов Front и таблиц */
export const plural = (value: number, forms: readonly [string, string, string]): string => pluralize(value, forms);
